import { TemplateEditorPage } from '@/pages/inspection/templates/TemplateEditorPage';
import { createFileRoute } from '@tanstack/react-router';

function TemplateEditorRoute() {
	const { templateId } = Route.useParams();
	return <TemplateEditorPage templateId={templateId} />;
}

export const Route = createFileRoute('/_authenticated/_app/inspection/templates/$templateId')({
	component: TemplateEditorRoute,
});
